<template>
  <section class="teacher-profile-section">
    <div class="teacher-profile-header">
      <b-img
        :src="teacherData.profile_photo"
        v-if="teacherData.profile_photo"
      ></b-img>
      <b-img src="/img/user-placeholder.png" v-else></b-img>
      <div class="name">
        <p>{{ teacherName }}</p>
        <span>{{ teacherData.place }}</span>
      </div>
      <div class="following" v-if="getUserRole === 'student'">
        <b-btn
          pill
          variant="primary"
          size="lg"
          @click="followTeacher"
          v-if="!isFollowing"
        >
          <font-awesome-icon icon="user-plus"></font-awesome-icon>
          <span class="ml-2">Follow</span>
        </b-btn>
        <b-btn
          pill
          variant="primary"
          size="lg"
          v-if="isFollowing"
          @click="unFollowTeacher"
        >
          <font-awesome-icon icon="user-times"></font-awesome-icon>
          <span class="ml-2">Following</span>
        </b-btn>
      </div>
    </div>
    <div class="teacher-profile-skills">
      <div class="bio" v-if="teacherData.description">
        {{ teacherData.description }}
      </div>
      <div class="skills-wrapper">
        <span>Skills:</span>
        <div class="skill-list">
          <div
            v-for="(skill, index) in teacherData.subjects"
            :key="index"
            class="skill-pill"
            v-bind:style="{ backgroundColor: skillColors[index] }"
          >
            {{ skill }}
          </div>
        </div>
        <!--<b-btn>20+</b-btn>-->
      </div>
    </div>
    <hr />
    <div
      class="teacher-profile-current-courses"
      v-if="teacherData.courses.length !== 0"
    >
      <p class="heading">Current Courses</p>
      <div class="teacher-profile-courses-list rounded-nav">
        <tiny-slider v-bind="tinySliderOptions">
          <div v-for="course in teacherData.courses" :key="course.course_id">
            <div class="teacher-profile-courses-list-item" v-if="course">
              <b-img :src="course.course_properties.imgUrl"></b-img>
              <div class="overlay">
                <div class="heading" @click="redirectToCourse(course)">
                  {{ course.name }}
                </div>
                <span>{{ course.subject }}</span>
              </div>
            </div>
          </div>
        </tiny-slider>
      </div>
    </div>
    <div
      class="teacher-profile-banner"
      style="background-image: url('/img/teachersbg.png')"
    >
      <div class="banner-details">
        <h4>Hello I am, {{ teacherName }}</h4>
        <p>I have added my teaching video please watch it.</p>
        <div class="play-button">
          <b-img src="/img/icons/svg/play-btn.svg"></b-img>
          <span>PLAY VIDEO</span>
        </div>
      </div>
    </div>
    <write-review
      :isTeacher="true"
      :courseId="teacherData.teacher_id"
      :courseName="teacherName"
      :rating="teacherData.rating"
      :review="review"
    />
    <div class="teacher-profile-testimonials">
      <h4 class="title">Testimonials</h4>
      <div class="rating-wrapper">
        <star-rating v-model="teacherData.rating" v-bind="starattribs" />
        <span class="rate">{{ teacherData.rating.toFixed(1) }}</span>
      </div>
      <b-row>
        <b-col cols="6" v-for="(review, i) in teacherReviews" :key="i">
          <div class="teacher-review-item">
            <b-img src="https://placeimg.com/80/80/people"></b-img>
            <div class="ml-3">
              <strong>{{ review.review_title }}</strong>
              <p>
                {{ review.review_text }}
              </p>
              <div class="user-details">
                <span>{{ review.user_name }}</span>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12 my-4 pb-5 d-flex justify-content-center">
          <!--<b-button size="lg" pill variant="primary">-->
          <!--<span>See More Reviews</span>-->
          <!--<font-awesome-icon icon="arrow-right" size="xs" />-->
          <!--</b-button>-->
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
import { teacherApi } from "../services/teacherApi";
import { mapGetters } from "vuex";
import { customerApi } from "../services/customerApi";
import { store } from "../store/store";
import WriteReview from "../components/Templates/WriteReview";

export default {
  name: "Teacher.vue",
  computed: {
    ...mapGetters("user", ["isAuthenticated", "getUserRole"]),
    ...mapGetters("teacher", ["getFollowingTeachers", "getAllTeachers"]),
    ...mapGetters("events", ["getFollowTeacher"])
  },
  components: {
    WriteReview
  },
  data() {
    return {
      skills: [
        "Music",
        "Painting",
        "Research",
        "Science",
        "Malayalam",
        "Maths",
        "Physics",
        "Biology"
      ],
      tinySliderOptions: {
        mouseDrag: true,
        loop: false,
        items: 1,
        gutter: 20,
        swipeAngle: 45,
        controls: false,
        nav: true,
        responsive: {
          640: {
            items: 3
          },
          1200: {
            items: 4
          }
        }
      },
      rating: 4,
      starattribs: {
        readOnly: true,
        starSize: 26,
        showRating: false,
        activeColor: "#faa30c"
      },
      teacherData: {},
      skillColors: [],
      teacherId: "",
      isFollowing: false,
      teacherReviews: [],
      review: {},
      teacherName: ""
    };
  },
  watch: {
    getFollowTeacher() {
      if (!this.getFollowTeacher) {
        this.followTeacherApi();
      }
    },
    getFollowingTeachers() {
      this.setIsFollowing();
    },
    isAuthenticated() {
      if (this.isAuthenticated) {
        this.getReview();
      }
    }
  },
  mounted() {
    this.teacherId = this.$route.query.teacherId;
    teacherApi.getTeacherByTeacherId(this.teacherId).then(res => {
      this.teacherData = res.data;
      this.teacherName = res.data.name;
    });
    this.setIsFollowing();
    this.getTeacherReviewsById();
    this.getReview();
  },
  methods: {
    redirectToCourse(course) {
      this.$router.push({
        path: "/course_description",
        query: { courseId: course.course_id }
      });
    },
    rand() {
      //  Generate Color variables with light tone
      return Math.floor(Math.random() * (255 - 200) + 200);
    },
    followTeacher() {
      if (this.isAuthenticated) {
        this.followTeacherApi();
      } else {
        store.dispatch("events/setFollowTeacher", true);
        this.$bvModal.show("modal-1");
      }
    },
    unFollowTeacher() {
      const teacherData = {
        teacher_id: this.teacherId
      };
      customerApi.unfollowTeacher(teacherData).then(res => {
        this.isFollowing = false;
        customerApi.getFollowingTeachers();
        this.getAllTeachers.forEach(teacher => {
          if (teacher.teacher_id === this.teacherId) {
            teacher.isFollowing = false;
          }
        });
      });
    },
    followTeacherApi() {
      const teacherData = {
        user_id: this.teacherId
      };
      customerApi.followTeacher(teacherData).then(res => {
        this.isFollowing = true;
        customerApi.getFollowingTeachers().then(res => {});
      });
    },
    setIsFollowing() {
      console.warn("inside set is Following");
      if (this.isAuthenticated) {
        this.getFollowingTeachers.forEach(teacher => {
          if (teacher.teacher_id === this.teacherId) {
            console.warn("inside if", teacher);
            this.isFollowing = true;
          }
        });
      } else {
        this.isFollowing = false;
      }
    },
    getTeacherReviewsById() {
      teacherApi.getTeacherReview(this.teacherId).then(res => {
        this.teacherReviews = res.data;
      });
    },
    getReview() {
      const TeacherData = {
        teacher_id: this.teacherId
      };
      customerApi
        .editTeacherReview(TeacherData)
        .then(res => {
          this.review = res.data
            ? res.data
            : {
                rating: 0
              };
        })
        .catch(e => {
          this.review = {
            rating: 0
          };
        });
    }
  },
  beforeMount() {
    for (let i = 0; i <= this.skills.length; i++) {
      this.skillColors[i] =
        "rgb(" + this.rand() + "," + this.rand() + "," + this.rand() + ")";
    }
  }
};
</script>

<style scoped></style>
